import { Typography } from "antd";
import React from "react";
import PaymentIntrumentSelection from "../paymentInstrumentSelection/PaymentIntrumentSelection";
import PyamentButton from "../../paymentButton/PaymentButton";
import { selectIsMobileLayout } from "../../../../slices/MobileLayoutSlice";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TranslateText from "../../../resuableComponents/TranslateText";

const Recommended = ({ recommendedMethodInfo }) => {
  const { t } = useTranslation();
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const issuers = useSelector((state) => state.paymentInstrumentIssuers.issuers);

  const slicedRecommendedMethodInfo = recommendedMethodInfo.slice(0, 2).map((info) => info?.issuer
    ? {
      ...info,
      issuers: issuers.find((i) => i?.code === info?.issuer?.name)?.title || info.title,
    }
    : info
  );
  return (
    <div className="recommended-root">
      <Typography
        className="dynamic-font-family"
        style={{ display: isMobileLayout ? "none" : "" }}
      >
        <TranslateText label={"RECOMMENDED_PAYMENT_OPTIONS"}>Recommended Payment Options</TranslateText>
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: isMobileLayout ? "" : "12px",
        }}
      >
        <PaymentIntrumentSelection data={slicedRecommendedMethodInfo} />
        <PyamentButton />
      </div>
    </div>
  );
};

export default Recommended;
